export const MachineUhtIcon = ({ color }: { color?: string }): JSX.Element => {
  color = color || '#E66C37';

  return (
    <svg width="22" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.6667 4.56002C12.8712 4.67864 13.0407 4.84935 13.1578 5.05475C13.2749 5.26015 13.3355 5.49292 13.3334 5.72935V10.0994C13.3334 10.5847 13.0707 11.0327 12.6467 11.268L8.64669 13.8307C8.44892 13.9407 8.22634 13.9985 8.00002 13.9985C7.7737 13.9985 7.55112 13.9407 7.35335 13.8307L3.35335 11.268C3.14525 11.1521 2.97188 10.9828 2.85116 10.7774C2.73044 10.5721 2.66675 10.3382 2.66669 10.1V5.72869C2.66669 5.24335 2.92935 4.79602 3.35335 4.56002L7.35335 2.17202C7.55708 2.0581 7.7866 1.99829 8.02002 1.99829C8.25344 1.99829 8.48296 2.0581 8.68669 2.17202L12.6867 4.56002H12.6667Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00002 8.00002C6.00002 8.53045 6.21073 9.03916 6.58581 9.41423C6.96088 9.78931 7.46959 10 8.00002 10C8.53045 10 9.03916 9.78931 9.41423 9.41423C9.78931 9.03916 10 8.53045 10 8.00002C10 7.46959 9.78931 6.96088 9.41423 6.58581C9.03916 6.21073 8.53045 6.00002 8.00002 6.00002C7.46959 6.00002 6.96088 6.21073 6.58581 6.58581C6.21073 6.96088 6.00002 7.46959 6.00002 8.00002Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
